import React, { Component } from "react";
import Slider from "react-slick";
import { DevelopmentData } from "../../db/DevelopmentData";
import { Col, Row, Container, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactStars from "react-rating-stars-component";
import "./CourseDesc.css";

export default class SimpleSlider extends Component {
  render() {
    const settings = {
      dots: false,
      infinite: true,
      autoplay: true,
      speed: 2000,
      slidesToShow: 4,
      slidesToScroll: 4,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
      ],
    };
    return (
      <Container className="py-5">
        <div className="dev-title">
          <h2>Development Courses</h2>
          <h5>Courses to get you started</h5>
        </div>
        <Container>
          <Slider {...settings}>
            {DevelopmentData.map((item, index) => {
              return (
                <Col key={item.id}>
                  <div className="walter">
                    <Link to={item.path}>
                      <Image
                        className="part-img"
                        variant="top"
                        fluid
                        src={item.image}
                      />
                      <div className="partner-p">{item.title}</div>
                      <p className="partner-a">{item.author}</p>
                      <div></div>
                      <div class="stary">
                        <span class="stary-p"> {item.rate}</span>
                        <div className="mask">
                          <ReactStars
                            count={5}
                            size={20}
                            activeColor="#eb8a2f"
                            value={item.rate}
                            isHalf={true}
                          />
                        </div>
                      </div>
                      <div className="part-price">RON {item.price}</div>
                      <div className="seller">{item.type}</div>
                    </Link>
                  </div>
                </Col>
              );
            })}
          </Slider>
        </Container>
      </Container>
    );
  }
}
